











import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EVENTS } from "@/lib/const";
import emitter from "@/lib/helpers/emitter";
import config from "@/config";

@Component({ name: "MainHeader" })
export default class MainHeader extends Vue {
  @Prop({ type: Boolean, default: false })
  public drawer!: boolean;

  @Prop({ type: Boolean, default: false })
  public hideMenu!: boolean;

  public loading: boolean = false;

  public get logoUrl() {
    if (!config.siteLogo) return "";
    else if (config.siteLogo.startsWith("/") || config.siteLogo.startsWith("http")) return config.siteLogo;
    return `${process.env.BASE_URL}${config.siteLogo}`;
  }

  public mounted() {
    emitter.on<any>(EVENTS.LOADING.CHANGE, (newLoading: boolean) => {
      this.loading = newLoading;
    });
  }
}
